import { render, staticRenderFns } from "./police.vue?vue&type=template&id=75f1539f&scoped=true"
import script from "./police.vue?vue&type=script&lang=js"
export * from "./police.vue?vue&type=script&lang=js"
import style0 from "./police.vue?vue&type=style&index=0&id=75f1539f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f1539f",
  null
  
)

export default component.exports